import { ESharedComponent } from "../../../../services/UI/State/ESharedComponent";
import { LevelProgressBarState } from "./LevelProgressBarState";
import { IsLevelProgressBarMounted } from "./LevelProgressBarLifecycle";
import { State } from "source/app/services/UI/State/State";

export function AnimateProgressBar(isAnimated: boolean) {
    if (!IsLevelProgressBarMounted()) {
        return;
    }

    State.ReadClass<LevelProgressBarState>(ESharedComponent.LevelProgressBar)
        .setState({ isAnimated });
}
